import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-097b396c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "latex-editor" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "input-area" }
const _hoisted_5 = { class: "preview" }
const _hoisted_6 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_7 = {
  key: 1,
  class: "preview-content"
}
const _hoisted_8 = { class: "right" }
const _hoisted_9 = { class: "tabs" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 0,
  class: "symbol"
}
const _hoisted_13 = { class: "symbol-tabs" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "symbol-pool" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "formula"
}
const _hoisted_18 = { class: "formula-title" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "footer" }

import { computed, onMounted, ref } from 'vue'
import { hfmath } from './hfmath'
import { FORMULA_LIST, SYMBOL_LIST } from '@/configs/latex'

import FormulaContent from './FormulaContent.vue'
import SymbolContent from './SymbolContent.vue'

import {
  Button,
  Input,
  message,
} from 'ant-design-vue'
interface Tab {
  label: string
  value: 'symbol' | 'formula'
}

interface LatexResult {
  latex: string
  path: string
  w: number
  h: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  value: {
    type: String,
    default: '',
  },
},
  emits: ["update", "close"],
  setup(__props, { emit }: { emit: ({
  (event: 'update', payload: LatexResult): void
  (event: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const TextArea = Input.TextArea

const tabs: Tab[] = [
  { label: '常用符号', value: 'symbol' },
  { label: '预置公式', value: 'formula' },
]





const formulaList = FORMULA_LIST
const symbolList = SYMBOL_LIST

const latex = ref('')
const toolbarState = ref<'symbol' | 'formula'>('symbol')
const textAreaRef = ref<HTMLTextAreaElement>()

const selectedSymbolKey = ref(SYMBOL_LIST[0].type)
const symbolPool = computed(() => {
  const selectedSymbol = SYMBOL_LIST.find(item => item.type === selectedSymbolKey.value)
  return selectedSymbol?.children || []
})

onMounted(() => {
  if (props.value) latex.value = props.value
})

const update = () => {
  if (!latex.value) return message.error('公式不能为空')

  const eq = new hfmath(latex.value)
  const pathd = eq.pathd({})
  const box = eq.box({})
  
  emit('update', {
    latex: latex.value,
    path: pathd,
    w: box.w + 32,
    h: box.h + 32,
  })
}

const insertSymbol = (latex: string) => {
  if (!textAreaRef.value) return
  textAreaRef.value.focus()
  document.execCommand('insertText', false, latex)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TextArea), {
            value: latex.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((latex).value = $event)),
            placeholder: "输入 LaTeX 公式",
            ref_key: "textAreaRef",
            ref: textAreaRef
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (!latex.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "公式预览"))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(FormulaContent, {
                  width: 518,
                  height: 138,
                  latex: latex.value
                }, null, 8, ["latex"])
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createElementVNode("div", {
              class: _normalizeClass(["tab", { 'active': tab.value === toolbarState.value }]),
              key: tab.value,
              onClick: ($event: any) => (toolbarState.value = tab.value)
            }, _toDisplayString(tab.label), 11, _hoisted_10)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_11, [
          (toolbarState.value === 'symbol')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(symbolList), (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["symbol-tab", { 'active': selectedSymbolKey.value === group.type }]),
                      key: group.type,
                      onClick: ($event: any) => (selectedSymbolKey.value = group.type)
                    }, _toDisplayString(group.label), 11, _hoisted_14))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(symbolPool), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "symbol-item",
                      key: item.latex,
                      onClick: ($event: any) => (insertSymbol(item.latex))
                    }, [
                      _createVNode(SymbolContent, {
                        latex: item.latex
                      }, null, 8, ["latex"])
                    ], 8, _hoisted_16))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formulaList), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "formula-item",
                    key: item.label
                  }, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(item.label), 1),
                    _createElementVNode("div", {
                      class: "formula-item-content",
                      onClick: ($event: any) => (latex.value =item.latex)
                    }, [
                      _createVNode(FormulaContent, {
                        width: 236,
                        height: 60,
                        latex: item.latex
                      }, null, 8, ["latex"])
                    ], 8, _hoisted_19)
                  ]))
                }), 128))
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_unref(Button), {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(Button), {
        class: "btn",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (update()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})